export default __webpack_public_path__ + "static/media/calendar_icon_blue.11a0e624.png";